module.exports = __webpack_public_path__ + "static/media/monitor_background.d776b754.svg";